import { useRoutes } from 'react-router-dom';
import { routers } from './pages/routers/index';
import './index.less';

function App() {
  return useRoutes(routers);
}

export default App;
